import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Overdrive from "react-overdrive";
import { POSTER_PATH, POSTER_PLACEHOLDER } from '../utils/const';

const Movie = ({ movie }) => (
  <Link to={`/${movie.id}`}>
    <Overdrive id={`${movie.id}`}>
      <Poster
        src={
          movie.poster_path === null
            ? `${POSTER_PLACEHOLDER}`
            : `${POSTER_PATH}${movie.poster_path}`
        }
        alt={movie.title}
      />
    </Overdrive>
  </Link>
);

export default Movie;

Movie.propTypes = {
  movie: PropTypes.shape({
    title: PropTypes.string.isRequired
  }).isRequired
};

export const Poster = styled.img`
  box-shadow: 0 0 35px black;
  width: 100%;
  min-width: 200px;
  max-width:280px
`;



// WEBPACK FOOTER //
// ./src/component/Movie.js